

import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App'
import './permission' 
import router from './router/index.js'
import  './assets/utils/utils.js'
import 'babel-polyfill' 
import { utils } from './assets/utils/utils.js' 


import { DatePicker } from 'element-ui';
Vue.use(DatePicker)

import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import Loading from 'vux/src/components/loading/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

Vue.component('loading', Loading)
Vue.component('toast', Toast)
Vue.use(ToastPlugin, { position: 'middle', isShowMask: true })
Vue.use(LoadingPlugin)
Vue.use(VueRouter)

Vue.config.productionTip = false
/* eslint-disable no-new */
let myThis = new Vue({
router,
render: (h) => h(App)
}).$mount('#app-box')


Vue.prototype.showToast = function(text,width="12rem",time=2000){
this.$vux.toast.show({
text: text,
width: width,
time: time,
type: 'text',
position: 'middle'
})
}
export default myThis


utils.getInfomation.init()



// WEBPACK FOOTER //
// ./src/main.js